<input
    kui-input
    type="{{ field.type }}"
    placeholder="{{ field.placeholder }}"
    #textField="ngModel"
    [disabled]="field.readonly"
    [minlength]="field.min || 0"
    [maxlength]="field.max || 1024"
    [ngModel]="value"
    (ngModelChange)="changeText($event)"
    [required]="field.required"
    autocomplete="new-password"
    [class.border-danger]="error || (textField.invalid && (textField.dirty || textField.touched))"
    [pattern]="pattern"
/>
@if (textField.invalid && (textField.dirty || textField.touched)) {
    <div class="invalid-feedback d-block">
        @if (textField.errors["required"]) {
            <div>
                {{ "FORMS.SHARED.REQUIRED" | translate: { field: field.title } }}
            </div>
        }
        @if (textField.errors["minlength"]) {
            <div>
                {{ "FORMS.TEXT.MIN" | translate: { field: field.title, min: field.min } }}
            </div>
        }
        @if (textField.errors["pattern"]) {
            <div>{{ patternErrorMessage | translate: { field: field.title } }}</div>
        }
    </div>
}
@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}
